import axiosInstance from "../axiosInstance";

const getDashboardResource = async (path) =>
  axiosInstance
    .get(path)
    .then((response) => {
      const result = response?.data;

      if (result?.error || result?.succeeded === false) {
        throw result;
      }

      return result;
    })
    .catch((error) => {
      throw error?.response?.data ?? error;
    });

export const getDashboard = async () =>
  getDashboardResource("/Dashboard/GetDashboard");

export const getApartmentsMap = async () =>
  getDashboardResource("/Dashboard/GetApartmentsMap");
